<template>
  <div class="unity-content-container">
    <div
      :class="mobile_webgl_class"
      v-if="app_type == 'mobile' && page_state == 2"
    >
      <MobileContainer></MobileContainer>
    </div>
    <div :class="webgl_class" v-if="app_type == 'desktop'">
      <div class="webgl-content">
        <div
          id="unityContainer"
          class="unityContainer"
          ref="unityContainer"
        ></div>
      </div>
      <transition name="fade" mode="out-in">
        <AppSidebar />
      </transition>

      <AudioManager ref="audio_manager" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import AudioManager from "../components/AudioManager";
import AppSidebar from "../components/AppSidebar";
import MobileContainer from "../components/MobileContainer";

export default {
  name: "UnityContainer",
  components: {
    AudioManager,
    AppSidebar,
    MobileContainer
  },
  data() {
    return {
      unityInstance: null,
      current_transition: "",
      transition_status: -1,
      initialized: false,
      safari_timer: null,
      unity_canvas: null
    };
  },
  computed: {
    ...mapState(["app_type", "page_state", "sections"]),
    ...mapGetters(["eventTag"]),
    mobile_webgl_class() {
      var class_str = "hidden-container  mx-auto";
      if (
        this.$store.state.page_state == 2 &&
        this.$store.state.app_state >= 0 &&
        this.$store.state.app_type == "mobile"
      ) {
        class_str += " active";
        if (!this.initialized) {
          switch (this.$store.state.initial_movement_mode) {
            case "SIMPLE":
              this.$store.dispatch("set_app_state", 2);

              break;
          }
          this.initialized = true;
        }
      }

      return class_str;
    },
    webgl_class() {
      var class_str = "hidden-container  mx-auto";
      if (
        this.$store.state.app_state >= 0 &&
        this.$store.state.page_state == 2 &&
        this.$store.state.app_type == "desktop"
      ) {
        class_str += " active";
        //setTimeout((function(){
        if (!this.initialized) {
          switch (this.$store.state.initial_movement_mode) {
            case "AUTO":
              this.switchState("AUTO");
              this.$bus.$emit("on-request-audio", "ambience");
              break;
            case "FREE":
              this.switchState("FREE");
              this.$store.dispatch("set_app_state", 2);

              this.$bus.$emit("on-request-audio", "ambience");
              this.$bus.$emit(
                "on-request-ambience-fade",
                this.$store.state.ambience_volume
              );

              break;
          }

          this.initialized = true;
          this.$ga.page("/" + this.eventTag + "/home");
          try {
            this.$ga.event(
              this.eventTag + "-unity",
              "end_loading",
              "end_loading",
              1
            );
          } catch (err) {}
        }
        //this.$bus.$emit('send_unity_msg', 'DestroyAnimation')
        //    console.log('cancel animation')
        //this.$store.dispatch('set_app_state', 2)
        //}).bind(this), 60);
      }
      return class_str;
    },
    unity_info() {
      return this.$store.state.unity_info;
    },
    app_state() {
      return this.$store.state.app_state;
    }
  },
  methods: {
    on_loader_progress(unityInstance, progress) {
      //window.UnityProgress(unityInstance, progress);
      this.$store.dispatch("set_unity_progress", progress);
    },
    toggle_video_click(e) {
      e.preventDefault();
      this.unityInstance.SendMessage("_App", "Toggle");
    },
    send_unity_msg(msg, param) {
      if (this.app_type == "mobile") {
        this.$bus.$emit("on-mobile-send-msg", msg, param);
        return;
      }
      console.log("send from js to unity", msg, param);
      if (msg == "JsRequestTransition" && param == 6) {
        setTimeout(
          function () {
            this.$bus.$emit(
              "on-request-ambience-fade",
              this.$store.state.ambience_volume
            );
            this.$store.dispatch("set_app_state", 2);
            this.switchState("FREE");
            this.$store.dispatch("set_current_section", "");
            //this.$bus.$emit('send_unity_msg', 'JsRequestSection', "7")
            //this.$bus.$emit('on-transition-started', '6');
            //this.$store.dispatch('set_popup_state', '');
          }.bind(this),
          400
        );

        return;
      } else if (msg == "JsRequestTransition" && param == 3) {
        //if audio doesn't end yet, ignore the request
        if (this.transition_status == 1) {
          return;
        }
      }
      try {
        if (param == null) {
          this.unityInstance.SendMessage("_App", msg);
        } else {
          this.unityInstance.SendMessage("_App", msg, param);
        }
      } catch (err) {}
    },
    on_transition_started(transition_id) {
      console.log("start transition", transition_id, this.current_transition);
      if (transition_id == this.current_transition) {
        return;
      }

      //console.log('start transition', transition_id)
      this.current_transition = transition_id;
      this.transition_status = 0;
      setTimeout(
        (() => {
          this.$bus.$emit("on-request-audio", transition_id);
        }).bind(this),
        100
      );
      this.$bus.$emit("on-request-ambience-fade", 0.06);
      this.$store.dispatch("set_current_section", transition_id);
    },
    on_transition_ended(transition_id) {
      //console.log('transitions ended')
      this.transition_status += 1;
      this.check_transition_status();
    },
    on_audio_ended() {
      this.transition_status += 1;
      this.check_transition_status();
    },

    //this is the logic for the guided tour
    check_transition_status() {
      if (this.$store.state.app_state > 0) {
        //console.log('unity is sending unneeded animation status')
        return;
      }
      if (this.transition_status >= 2) {
        //continue transition
        //
        //console.log("current transition", this.current_transition);
        switch (this.current_transition) {
          case "7":
            //this.$store.dispatch('set_image_popup', this.current_trantision);
            //this.$bus.$emit('on-request-ambience-fade', 0.3)

            break;
          default:
            if (
              this.current_transition == "1" ||
              this.current_transition == "2"
            ) {
              console.log("call slideshow popup");
              this.$store.dispatch(
                "set_slideshow_popup",
                this.current_transition
              );
            } else if (this.current_transition == "3") {
              //if the popup has been closed
              //then now popup and audio are over, so let's move on.
              //Note that we always open the popup first, so this check will always happen
              //when the popup is open, or has been closed (never when it hasn't been opened yet).
              console.log(
                "section 3 audio is done, is popup done?",
                this.$store.state.popup_state
              );
              if (this.$store.state.popup_state == "") {
                this.$bus.$emit("send_unity_msg", "JsRequestTransition", 3);
              }
              //this.$store.dispatch("set_image_popup", this.current_transition);
            } else if (this.current_transition == "5") {
              //this.$store.dispatch('set_links_popup', this.current_transition);
              this.$bus.$emit(
                "send_unity_msg",
                "JsRequestTransition",
                this.current_transition * 1
              );
            } else if (this.current_transition == "6") {
              //this.$store.dispatch('set_contact_popup', this.current_transition);

              this.$bus.$emit(
                "send_unity_msg",
                "JsRequestTransition",
                this.current_transition * 1
              );
            } else {
              this.$store.dispatch("set_video_popup", this.current_transition);
            }

            var next_transition_volume =
              this.current_transition == "4" ? 0 : 0.3;
            this.$bus.$emit("on-request-ambience-fade", next_transition_volume);
            break;
        }
        this.transition_status = -1;
      } else if (
        this.transition_status == 1 &&
        this.current_transition == "3"
      ) {
        // this.$bus.$emit('on-request-ambience-fade',  this.$store.state.ambience_volume)
        this.$store.dispatch("set_image_popup", this.current_transition);
      } else if (
        this.transition_status == 1 &&
        this.current_transition == "6"
      ) {
        // this.$bus.$emit('on-request-ambience-fade',  this.$store.state.ambience_volume)
      }
    },
    on_section_anim_ended(transition_id) {
      console.log("anim section ended", transition_id);
      //if (transition_id != "7") {
      this.on_area_btn_click(transition_id);
      //}
    },
    on_area_btn_click(area_id) {
      var area_parts = area_id.split(":");
      var area = area_parts[0];
      this.call_section_content(area);
    },

    call_section_content(section_id) {
      for (let i = 0; i < this.sections.length; i++) {
        let section = this.sections[i];
        if (section.id == section_id) {
          this.$store.dispatch("set_current_section", section.id);
          this.$store.dispatch("set_popup_state", section.popup_type);

          try {
            let section_name = section.name
              .split("<br>")
              .join("-")
              .split(" ")
              .join("-")
              .toLowerCase();
            this.$ga.event(
              this.eventTag + "-section",
              "visit",
              section_name,
              1
            );
          } catch (err) {}
          break;
        }
      }
    },
    on_cancel_guided_tour() {
      this.$store.dispatch("set_app_state", 2);
      this.$bus.$emit("on-request-audio-stop", this.current_transition);

      this.switchState("FREE");
      this.current_transition = "0";
      this.$store.dispatch("set_simple_val", {
        name: "popup_video_src",
        val: ""
      });
    },
    on_restart_guided_tour() {
      console.log(
        "restarting guided tour, and ambience should be ",
        this.$store.state.ambience_volume
      );
      this.$store.dispatch("set_app_state", 0);
      this.$bus.$emit(
        "on-request-ambience-fade",
        this.$store.state.ambience_volume
      );

      this.switchState("AUTO");
    },
    switchState(appMode) {
      this.unityInstance.SendMessage("_App", "JsSwitchState", appMode);
      if (appMode == "FREE" && !this.$store.state.instructions_shown) {
        setTimeout(
          function () {
            this.$store.dispatch("set_popup_state", "instructions");
          }.bind(this),
          1500
        );
      }
    },
    monitor_canvas_dimensions() {
      if (
        this.$refs.unityContainer.parentNode.clientHeight !=
        this.unity_canvas.height
      ) {
        this.unity_canvas.width = this.$refs.unityContainer.parentNode.clientWidth;
        this.unity_canvas.height = this.$refs.unityContainer.parentNode.clientHeight;
      }
    },
    do_resize() {
      if (!this.$refs.unityContainer) return;
      this.$refs.unityContainer.style.height = "50vh";
      var new_height =
        this.$refs.unityContainer.parentNode.clientHeight > 450
          ? this.$refs.unityContainer.parentNode.clientHeight + "px"
          : "65vh";
      try {
        if (this.$store.state.browser_is_mobile && new_height != "65vh") {
          new_height = "75vh";
        }
      } catch (err) {}
      this.$refs.unityContainer.style.height = new_height;
    },
    fix_dimensions() {
      //this.do_resize();
      window.addEventListener(
        "resize",
        function () {
          this.do_resize();
        }.bind(this)
      );
    },
    on_request_unity_load() {
      this.unityInstance = UnityLoader.instantiate(
        this.$refs.unityContainer,
        "static/Build/webglbuild.json",
        {
          onProgress: this.on_loader_progress.bind(this)
        }
      );

      try {
        this.$ga.event(
          this.eventTag + "-unity",
          "start_loading",
          "start_loading",
          1
        );
      } catch (err) {}

      if (
        this.$store.state.browser == "Safari" &&
        UnityLoader.SystemInfo.hasWebGL <= 1
      ) {
        this.unity_canvas = this.$refs.unityContainer.getElementsByTagName(
          "canvas"
        )[0];
        // this.safari_timer = setInterval(
        //   function () {
        //     this.monitor_canvas_dimensions();
        //   }.bind(this),
        //   2000
        // );
      }
    },
    on_video_open() {
      console.log("video popup was opened");
      this.$bus.$emit("on-request-fade-and-stop", "intro");
    }
  },
  mounted() {
    this.$bus.$on("send_unity_msg", this.send_unity_msg);
    this.$bus.$on("on-audio-end", this.on_audio_ended);
    this.$bus.$on("on-transition-started", this.on_transition_started);
    this.$bus.$on("on-transition-ended", this.on_transition_ended);
    this.$bus.$on("on-section-anim-ended", this.on_section_anim_ended);
    this.$bus.$on("on-area-btn-click", this.on_area_btn_click);
    this.$bus.$on("on-cancel-guided-tour", this.on_cancel_guided_tour);
    this.$bus.$on("on-restart-guided-tour", this.on_restart_guided_tour);
    this.$bus.$on("on-request-unity-load", this.on_request_unity_load);

    this.$bus.$on("on-video-open", this.on_video_open);
    if (
      this.$store.state.browser == "Safari" &&
      UnityLoader.SystemInfo.hasWebGL <= 1
    ) {
      // this.safari_timer = setInterval(
      //   function () {
      //     this.monitor_canvas_dimensions();
      //   }.bind(this),
      //   2000
      // );

      this.$bus.$emit("is-safari", true);
    }

    this.fix_dimensions();
    /*setTimeout((function(){
        this.$bus.$emit('send_unity_msg', 'DestroyAnimation')
        console.log('cancel animation')
        this.$store.dispatch('set_app_state', 2)
      }).bind(this), 8000);*/
  },
  watch: {
    webgl_class(val) {
      this.$nextTick(this.do_resize);
    }
  }
};
</script>
<style>
.unity-content-container {
  display: flex;
  align-items: stretch;
}
.webgl-content * {
  border: 0;
  margin: 0;
  padding: 0;
}
.webgl-content {
  width: 100%;
  flex: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: stretch;
}

.webgl-content .logo,
.progress {
  position: absolute;
  left: 50%;
  bottom: 30px;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}
.webgl-content .logo {
  width: 154px;
  height: 130px;
}
.webgl-content .progress {
  height: 18px;
  width: 50%;
  margin-top: 0;
}
.webgl-content .progress .empty {
  float: right;
  width: 100%;
  height: 100%;
  display: inline-block;
}
.webgl-content .progress .full {
  float: left;
  width: 0%;
  height: 100%;
  display: inline-block;
}

.webgl-content .logo.Dark {
  background-image: none;
}
.webgl-content .progress.Dark .empty {
  background: #101010;
}
.webgl-content .progress.Dark .full {
  background: green;
}

.webgl-content .footer {
  margin-top: 5px;
  height: 38px;
  line-height: 38px;
  font-family: Helvetica, Verdana, Arial, sans-serif;
  font-size: 18px;
}
.webgl-content .footer .webgl-logo,
.title,
.fullscreen {
  height: 100%;
  display: inline-block;
  background: transparent center no-repeat;
}
.webgl-content .footer .webgl-logo {
  width: 204px;
  float: left;
}
.webgl-content .footer .title {
  margin-right: 10px;
  float: right;
}
.webgl-content .footer .fullscreen {
  width: 38px;
  float: right;
}
.unityContainer {
  width: 100%;
  xmax-height: 60vh;
}
.active .unityContainer {
  height: 50vh;
  overflow: hidden;
}
.webgl-content canvas {
  height: 100% !important;
}

.is-safari .webgl-content {
}
.is-safari.active .unityContainer {
  display: block;
}

.is-safari.active .webgl-content canvas {
  xwidth: 50% !important;
  xheight: 50% !important;
  xtransform: scale(1.6) translateX(31.25%) translateY(31.25%);
  xtransform: scale(2) translateX(25%) translateY(25%);
}

.hidden-container {
  height: 6px;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.5s;
  transition-delay: 0.7s;
  width: 100%;
  flex-flow: column;
  position: relative;

  justify-content: flex-end;
  align-items: stretch;
}
.hidden-container.active {
  flex: 1;
  opacity: 1 !important;
  display: flex;
  height: auto;
}

.app_sidebar {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90vw;
  margin: 15px auto;
  border-radius: 10px;
}
.webgl-container {
  flex: 1;
}

@media screen and (min-width: 1100px) and (-webkit-min-device-pixel-ratio: 1.5),
  screen and (min-width: 1100px) and (min-resolution: 192dpi) {
  .hidden-container.active {
    justify-content: center;
  }
  .webgl-content {
    flex: 0;
    min-height: 550px;
    height: 60vh;
    max-width: 1100px !important;
    margin-left: auto;
    margin-right: auto;
  }
  .is-safari .webgl-content canvas {
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UnityContainer.vue